import { render, staticRenderFns } from "./SharePotatochips.vue?vue&type=template&id=67c1dc2c&scoped=true"
import script from "./SharePotatochips.vue?vue&type=script&lang=js"
export * from "./SharePotatochips.vue?vue&type=script&lang=js"
import style0 from "./SharePotatochips.vue?vue&type=style&index=0&id=67c1dc2c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c1dc2c",
  null
  
)

export default component.exports